import { render } from "./MerchantListPage.vue?vue&type=template&id=4ba9eb52&scoped=true"
import script from "./MerchantListPage.vue?vue&type=script&lang=js"
export * from "./MerchantListPage.vue?vue&type=script&lang=js"

import "./MerchantListPage.vue?vue&type=style&index=0&id=4ba9eb52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ba9eb52"

export default script